import React from 'react';

import Context from '../../../../../context';

import Paymentonline2CompanyScreen from "../index";
import {useQuery} from "react-query";
import values from "../../../../../values";
import api from "../../../../../api";
import {PaymentOnline2CompanyNamespace} from "../../../../../types/paymentOnline2Company.namespace";

const PaymentOnline2CompanyContainer: React.FC = (): React.ReactElement => {

  // # =================================================================================================================
  // # --------------------------------------------- Start Validate Values ---------------------------------------------

  const [selectedFactors, setSelectedFactors] = React.useState<Array<string>>([]);
  const [factorRequest, setFactorRequest] = React.useState<PaymentOnline2CompanyNamespace.IFactorRequest>({
    limit: 10,
    page: 1,
  })

  // # ---------------------------------------------- End Validate Values ----------------------------------------------
  // # =================================================================================================================

  // ! =================================================================================================================
  // ! ------------------------------------------------ Start Call API -------------------------------------------------

  // ? Panel-wide academic year (سال تحصیلی). It has to be in the query key as well as the request, otherwise
  // ? react-query serves the previous year's cached rows when the year is switched.
  const { selectedYear } = React.useContext(Context.AcademicYear);

  const companyFactors = useQuery(
    [values.useQueryKeys.parentTransaction, factorRequest, selectedYear?._id],
    () => api.get.administrator.getPaymentOnline2Company({ ...factorRequest, academicYear: selectedYear?._id })
  );

  // ! ------------------------------------------------- End Call API --------------------------------------------------
  // ! =================================================================================================================

  // ? =================================================================================================================
  // ? ----------------------------------------------- Start Return View -----------------------------------------------

  return (
    <Context.PaymentOnline2CompanyContext.Provider value={{
      reFetch: companyFactors.refetch,
      factorRequest  ,
      selectedFactors,
      setFactorRequest  ,
      setSelectedFactors,
    }}>
      <Paymentonline2CompanyScreen rqData={companyFactors} />
    </Context.PaymentOnline2CompanyContext.Provider>
  );

  // ? ------------------------------------------------ End Return View ------------------------------------------------
  // ? =================================================================================================================
}

export default PaymentOnline2CompanyContainer;
